/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { useSelector } from 'react-redux';

import CustomerNumber from './RegularUser/Forms/CustomerNumber';
import Image from '../../../../common/Image';
import getSiteConfig from '../../../../utils/getSiteConfig';
import { getIsBigGiftList } from '../../../../state/ducks/Common/Common-Selectors';
import AccountHome from '../../../MyAccount/AccountHome';

const MobileRegularUser = () => {
    const hasBrandSpecific = getSiteConfig('phoneNumber')?.props?.children?.includes('1-877-322-1200');
    const isBigGiftlist = useSelector(getIsBigGiftList);

    return (
        <>
            <h1>
                <AccountHome disablePageView />
                Gift List
            </h1>
            {isBigGiftlist ? (
                <div>
                    Wow, your gift list is too big to display online. Please contact customer service for assistance {getSiteConfig('phoneNumber')}
                </div>
            ) : (
                <>
                    <p>
                        We’re sorry. We cannot find a Gift List with your email
                        address. Please try using one of the options below, or call
                        us at {getSiteConfig('phoneNumber')}.
                    </p>
                    <p>
                        If you have a catalog, you can find your customer number on
                        the back.
                    </p>
                    <h2 className="margin-top-2x">
                        Option A: Enter Customer Number
                    </h2>
                    {hasBrandSpecific && (
                        <Image
                            src="//cdn1.harryanddavid.com/wcsstore/HarryAndDavid/images/customer-number.png"
                            alt=""
                        />
                    )}

                    <CustomerNumber hasBrandSpecific={hasBrandSpecific} />
                </>
            )}
        </>
    );
};

export default MobileRegularUser;
